document.addEventListener("DOMContentLoaded", () => {
  // Desktop only
  const isDesktop = window.matchMedia("(min-width: 990px)").matches;
  if (!isDesktop) return;

  document.querySelectorAll(".header__inline-menu details").forEach((details) => {
    let closeTimer;

    details.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
      details.setAttribute("open", "open");
    });

    details.addEventListener("mouseleave", () => {
      closeTimer = setTimeout(() => {
        details.removeAttribute("open");
      }, 120);
    });
  });
});
